import React from "react";
import { Link } from "react-router-dom";

function ShopQuickNav() {
  return (
    <div className="sticky top-20 md:top-20 z-40 bg-white/95 backdrop-blur-sm rounded-3xl shadow-xl mb-16 py-4 px-4 md:px-8">
      <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
        <a
          href="/shop#storybooks"
          className="w-full sm:w-auto bg-sky-400 hover:bg-sky-500 text-white font-black text-xl md:text-2xl px-8 py-4 rounded-2xl shadow-lg transform transition-all duration-300 hover:scale-105 hover:rotate-1 active:scale-95 text-center"
          style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>📚 Go To STORYBOOKS


        </a>
        <a
          href="/shop#apparel"
          className="w-full sm:w-auto bg-lime-400 hover:bg-lime-500 text-white font-black text-xl md:text-2xl px-8 py-4 rounded-2xl shadow-lg transform transition-all duration-300 hover:scale-105 hover:rotate-1 active:scale-95 text-center"
          style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>👕 Go To APPAREL


        </a>
      </div>
    </div>);

}

export default ShopQuickNav;